<template>
  <v-layout row wrap>
    <v-btn
      v-if="navigation"
      icon
      class="margin-auto"
      @click="navigateBefore"
    >
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
      <v-layout row wrap mx-1>
        <v-flex
          :sm4="datePickerVisible"
          class="margin-auto"
        >
          <v-autocomplete
            ref="select-daterange"
            :items="choices"
            :value="selected"
            item-text="text"
            item-value="value"
            label="Zeitraum"
            hide-details
            :menu-props="{
              maxHeight: '550px',
              maxWidth: '550px'
            }"
            single-line
            @change="onChange"
          />
        </v-flex>
        <v-flex
          v-if="datePickerVisible"
          sm4
          xs12
          class="margin-auto"
          pl-1
        >
          <r-datetextpicker
            :value="value.start"
            hide-details
            @input="submitStartDate"
          />
        </v-flex>
        <v-flex
          v-if="datePickerVisible"
          sm4
          xs12
          class="margin-auto"
          pl-1
        >
          <r-datetextpicker
            :value="value.end"
            hide-details
            @input="submitEndDate"
          />
        </v-flex>
      </v-layout>
    <v-btn
      v-if="navigation"
      icon
      @click="navigateNext"
      class="margin-auto"
    >
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
import moment from 'moment'
import datetextpicker from './customComponents/r-datetextpicker'
import { mapGetters } from 'vuex'

export default {
  components: {
    'r-datetextpicker': datetextpicker
  },
  props: {
    value: {
      type: Object,
      default: () => ({start: moment(), end: moment()})
    },
    navigation: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      datePickerVisible: false,
      forceDatePickerVisible: false,
      selected: null,
      choices: [
        {value: 'get7Days', text: 'Die letzten 7 Tage'},
        {value: 'get30Days', text: 'Die letzten 30 Tage'},
        {value: 'get3Months', text: 'Die letzten 3 Monate'},
        {value: 'get6Months', text: 'Die letzten 6 Monate'},
        { divider: true },
        {value: 'currentWeek', text: 'Aktuelle Woche'},
        {value: 'currentMonth', text: 'Aktueller Monat'},
        {value: 'currentQuarter', text: 'Aktuelles Quartal'},
        {value: 'currentHalfYear', text: 'Aktuelles Halbjahr'},
        {value: 'currentYear', text: 'Aktuelles Jahr'},
        { divider: true },
        {value: 'lastWeek', text: 'Vorwoche'},
        {value: 'vormonat', text: 'Vormonat'},
        {value: 'customDate', text: 'Individueller Zeitraum'},
        { divider: true },
        {value: 'unfiltered', text: 'Gesamter Zeitraum'},
      ],
      defaultPreset: 'currentWeek',
    }
  },
  created () {
    if (this.profile.daterange_default !== undefined) {
     this.onChange(this.profile.daterange_default)
    }
    else {
      let unwatch = this.$watch('profile', () => {
        this.onChange(this.profile.daterange_default)
        unwatch()
      })
    }
  },
  methods: {
    onChange (selected) {
      this.selected = selected
      const fun = this[this.selected]
      if (fun) {
        const settings = fun()
        this.$emit('input', {
          selection: this.selected,
          start: settings.start,
          end: settings.end,
        })
        this.datePickerVisible = settings.showPickers
        this.forceDatePickerVisible = this.datePickerVisible
      }
    },
    hideDatePicker () {
      this.datePickerVisible = false
    },
    showDatePicker () {
      this.datePickerVisible = true
    },
    submitStartDate (value) {
      this.$emit('input', {
        selection: this.selected,
        start: value,
        end: this.value.end,
      })
    },
    submitEndDate (value) {
      this.$emit('input', {
        selection: this.selected,
        start: this.value.start,
        end: value,
      })
    },
    get7Days () {
      return {
        showPickers: false,
        start: moment().subtract(6, 'd'),
        end: moment()
      }
    },
    get30Days () {
      return {
        showPickers: false,
        start: moment().subtract(30, 'd'),
        end: moment()
      }
    },
    get3Months () {
      return {
        showPickers: false,
        start: moment().subtract(3, 'M'),
        end: moment()
      }
    },
    get6Months () {
      return {
        showPickers: false,
        start: moment().subtract(6, 'M'),
        end: moment()
      }
    },
    currentWeek () {
      return {
        showPickers: false,
        start: moment().startOf('isoWeek'),
        end: moment().startOf('isoWeek').add(6, 'd')
      }
    },
    currentMonth () {
      return {
        showPickers: false,
        start: moment().startOf('month'),
        end: moment().endOf('month')
      }
    },
    currentQuarter () {
      return {
        showPickers: false,
        start: moment().startOf('quarter'),
        end: moment().endOf('quarter')
      }
    },
    currentHalfYear () {
      var date = new Date()
      var y = date.getFullYear()
      var m = date.getMonth()
      var firstDay = null
      var lastDay = null
      if (m >= 0 && m <= 5) {
        firstDay = new Date(y, 0, 1)
        lastDay = new Date(y, 6, 0)
      } else {
        firstDay = new Date(y, 6, 1)
        lastDay = new Date(y, 12, 0)
      }
      return {
        showPickers: false,
        start: moment(firstDay),
        end: moment(lastDay)
      }
    },
    currentYear () {
      return {
        showPickers: false,
        start: moment().startOf('year'),
        end: moment().endOf('year')
      }
    },
    lastWeek () {
      return {
        showPickers: false,
        start: moment().startOf('isoWeek').subtract(7, 'd'),
        end: moment().startOf('isoWeek').subtract(1, 'd')
      }
    },
    vormonat () {
      var date = new Date()
      var y = date.getFullYear()
      var m = date.getMonth()
      var firstDay = new Date(y, m - 1, 1)
      var lastDay = new Date(y, m, 0)
      return {
        showPickers: false,
        start: moment(firstDay),
        end: moment(lastDay)
      }
    },
    customDate () {
      return {
        showPickers: true,
        start: this.value.start,
        end: this.value.end,
      }
    },
    unfiltered () {
      return {
        showPickers: false,
        start: moment("1900-01-01"),
        end: moment("2100-01-01")
      }
    },
    navigateBefore () {
      this.$emit('input', {
        selection: this.selected,
        start: this.value.start.subtract(7, 'd'),
        end: this.value.end.subtract(7, 'd'),
      })
    },
    navigateNext () {
      this.$emit('input', {
        selection: this.selected,
        start: this.value.start.add(7, 'd'),
        end: this.value.end.add(7, 'd'),
      })
    },
  },
  watch: {
    value: {
      handler () {
        if (!this.value) {
          this.selected = this.defaultPreset
        }
        if (!this.forceDatePickerVisible) {
          for (let i = 0; i < this.choices.length; i++) {
            const funName = this.choices[i].value
            if (!funName) {
              continue
            }
            const fun = this[funName]
            const settings = fun()
            if (!settings.showPickers && settings.start.isSame(this.value.start) && settings.end.isSame(this.value.end)) {
              this.datePickerVisible = settings.showPickers
              this.selected = funName
              return
            }
          }
        }
        this.selected = 'customDate'
        this.datePickerVisible = true
        this.forceDatePickerVisible = false
      },
      immediate: true,
    },
    datePickerVisible () {
      this.$emit('size-hint', {needMoreSpace: this.datePickerVisible})
    },
  },
  computed: {
    ...mapGetters(['profile'])
  }
}
</script>

<style>
.list__tile {
    height: auto;
    min-height: 33px;
  }
</style>

<style lang="scss" scoped>
.margin-auto {
  margin: auto;
}
</style>
